<button
    type="button"
    [disabled]="disabled ? 'disabled' : undefined"
    class="aa-btn"
    [class.pressed]="pressed"
    [ngClass]="getClassNames()"
    (click)="onClick()"
    [style.width]="btnWidth"
>
    <span *ngIf="btnText; else ngContent">
        {{ btnText }}
    </span>
    <ng-template #ngContent>
        <ng-content></ng-content>
    </ng-template>
</button>
